module.exports = __webpack_public_path__ + "img/img-sale-sec-10.png";